(function () {
  document.querySelectorAll('[data-dp-benefits-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var content = btn.parentElement.querySelector('[data-dp-benefits-content]');
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      if (content) content.hidden = expanded;
    });
  });
})();